import enActivity from './locales/en/activity.json';
import enAlerts from './locales/en/alerts.json';
import enAuth from './locales/en/auth.json';
import enCommon from './locales/en/common.json';
import enCompany from './locales/en/company.json';
import enConfiguration from './locales/en/configuration.json';
import enCounts from './locales/en/counts.json';
import enCustomers from './locales/en/customers.json';
import enDataTools from './locales/en/dataTools.json';
import enDocuments from './locales/en/documents.json';
import enErrors from './locales/en/errors.json';
import enHome from './locales/en/home.json';
import enLocations from './locales/en/locations.json';
import enOperations from './locales/en/operations.json';
import enOrders from './locales/en/orders.json';
import enPayments from './locales/en/payments.json';
import enPos from './locales/en/pos.json';
import enPromotions from './locales/en/promotions.json';
import enRegisters from './locales/en/registers.json';
import enProducts from './locales/en/products.json';
import enReports from './locales/en/reports.json';
import enProfile from './locales/en/profile.json';
import enStock from './locales/en/stock.json';
import enSuppliers from './locales/en/suppliers.json';
import enTransfers from './locales/en/transfers.json';
import enUsers from './locales/en/users.json';
import enValidation from './locales/en/validation.json';
import frActivity from './locales/fr/activity.json';
import frAlerts from './locales/fr/alerts.json';
import frAuth from './locales/fr/auth.json';
import frCommon from './locales/fr/common.json';
import frCompany from './locales/fr/company.json';
import frConfiguration from './locales/fr/configuration.json';
import frCounts from './locales/fr/counts.json';
import frCustomers from './locales/fr/customers.json';
import frDataTools from './locales/fr/dataTools.json';
import frDocuments from './locales/fr/documents.json';
import frErrors from './locales/fr/errors.json';
import frHome from './locales/fr/home.json';
import frLocations from './locales/fr/locations.json';
import frOperations from './locales/fr/operations.json';
import frOrders from './locales/fr/orders.json';
import frPayments from './locales/fr/payments.json';
import frPos from './locales/fr/pos.json';
import frPromotions from './locales/fr/promotions.json';
import frRegisters from './locales/fr/registers.json';
import frProducts from './locales/fr/products.json';
import frReports from './locales/fr/reports.json';
import frProfile from './locales/fr/profile.json';
import frStock from './locales/fr/stock.json';
import frSuppliers from './locales/fr/suppliers.json';
import frTransfers from './locales/fr/transfers.json';
import frUsers from './locales/fr/users.json';
import frValidation from './locales/fr/validation.json';

export const NAMESPACES = [
  'common',
  'auth',
  'home',
  'company',
  'configuration',
  'users',
  'products',
  'locations',
  'dataTools',
  'operations',
  'transfers',
  'counts',
  'customers',
  'suppliers',
  'orders',
  'payments',
  'documents',
  'promotions',
  'registers',
  'pos',
  'stock',
  'profile',
  'activity',
  'alerts',
  'reports',
  'errors',
  'validation',
] as const;

export const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    home: enHome,
    company: enCompany,
    configuration: enConfiguration,
    users: enUsers,
    products: enProducts,
    locations: enLocations,
    dataTools: enDataTools,
    operations: enOperations,
    transfers: enTransfers,
    counts: enCounts,
    customers: enCustomers,
    suppliers: enSuppliers,
    orders: enOrders,
    payments: enPayments,
    documents: enDocuments,
    promotions: enPromotions,
    pos: enPos,
    registers: enRegisters,
    stock: enStock,
    profile: enProfile,
    activity: enActivity,
    alerts: enAlerts,
    reports: enReports,
    errors: enErrors,
    validation: enValidation,
  },
  fr: {
    common: frCommon,
    auth: frAuth,
    home: frHome,
    company: frCompany,
    configuration: frConfiguration,
    users: frUsers,
    products: frProducts,
    locations: frLocations,
    dataTools: frDataTools,
    operations: frOperations,
    transfers: frTransfers,
    counts: frCounts,
    customers: frCustomers,
    suppliers: frSuppliers,
    orders: frOrders,
    payments: frPayments,
    documents: frDocuments,
    promotions: frPromotions,
    pos: frPos,
    registers: frRegisters,
    stock: frStock,
    profile: frProfile,
    activity: frActivity,
    alerts: frAlerts,
    reports: frReports,
    errors: frErrors,
    validation: frValidation,
  },
} as const;
